<div class="content">
  <button mat-icon-button class="close-button bg-transparent" mat-dialog-close>
    <mat-icon aria-hidden="false">close</mat-icon>
  </button>
  <div class="text-center mat-dialog-title">Üzenet</div>
  <mat-tab-group mat-stretch-tabs>
    <mat-tab label="Új üzenet">
      <form [formGroup]="newMessage" class="mt-2" (ngSubmit)="send()">
        <div class="flex-space-between">
          <label class="col-5">Üzenet típusa</label>
          <mat-form-field class="col-6" appearance="outline">
            <mat-select formControlName="messageType">
              <mat-option *ngFor="let type of messageTypes" [value]="type[0]">{{
                messagesTypeString[type[0]]
                }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="fix-height">
          <div
            *ngIf="isSelectedMessageType(messageType.SINGLE)"
            class="flex-space-between single"
            formGroupName="single"
          >
            <label class="col-5">Címzett lajstromjele, vagy azonosítója</label>
            <mat-form-field class="col-6" appearance="outline">
              <input matInput type="text" formControlName="id" />
            </mat-form-field>
          </div>
          <div
            *ngIf="isSelectedMessageType(messageType.GROUP)"
            class="flex-space-between"
            formGroupName="group"
          >
            <label class="col-5">Címzett csoport neve</label>
            <mat-form-field class="col-6" appearance="outline">
              <input matInput type="text" formControlName="groupName" [matAutocomplete]="auto" />
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
<!--          <div-->
<!--            *ngIf="isSelectedMessageType(messageType.GROUP)"-->
<!--            class="flex-space-between"-->
<!--            formGroupName="group"-->
<!--          >-->
<!--            <label class="col-5">Címzettek azonosítói</label>-->
<!--            <mat-form-field class="col-6" appearance="outline">-->
<!--              <input matInput type="text" formControlName="ids" />-->
<!--            </mat-form-field>-->
<!--          </div>-->
          <label class="my-2 col-12" *ngIf="isSelectedMessageType(messageType.ALL)">
            Központi koordináta
          </label>
          <div
            *ngIf="isSelectedMessageType(messageType.ALL)"
            class="flex-space-between"
            formGroupName="all"
          >
            <label class="col-5">Szélesség</label>
            <mat-form-field class="col-6" appearance="outline">
              <input matInput type="number" formControlName="long" />
            </mat-form-field>
          </div>
          <div
            *ngIf="isSelectedMessageType(messageType.ALL)"
            class="flex-space-between"
            formGroupName="all"
          >
            <label class="col-5">Magasság</label>
            <mat-form-field class="col-6" appearance="outline">
              <input matInput type="number" formControlName="lat" />
            </mat-form-field>
          </div>
          <div
            *ngIf="isSelectedMessageType(messageType.ALL)"
            class="flex-space-between"
            formGroupName="all"
          >
            <label class="col-5 mt-1">Hatótávolság sugara</label>
            <mat-form-field class="col-6" appearance="outline">
              <input matInput class="right-align" type="number" formControlName="radius" />
              <span matSuffix>&nbsp;km</span>
            </mat-form-field>
          </div>
        </div>
        <label class="col-5 mt-2">Üzenet</label>
        <mat-form-field class="col-12" appearance="outline">
          <textarea matInput formControlName="message" maxlength="128" ></textarea>
        </mat-form-field>
        <div class="flex-center mt-4">
          <button mat-flat-button color="primary" type="submit">Küldés</button>
        </div>
      </form>
    </mat-tab>
    <mat-tab label="Üzenetek">
      <div *ngIf="dataSource.data.length > 0;then messages else noMessage" class="messages"></div>
      <ng-template #messages>
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Dátum</th>
            <td mat-cell *matCellDef="let message">{{ message.createdAt.toDateString() }}</td>
          </ng-container>
          <ng-container matColumnDef="messageType">
            <th mat-header-cell *matHeaderCellDef>Típus</th>
            <td mat-cell *matCellDef="let message">{{ messagesTypeString[message.messageType] }}</td>
          </ng-container>
          <ng-container matColumnDef="addressees">
            <th mat-header-cell *matHeaderCellDef>Címzettek</th>
            <td mat-cell *matCellDef="let message">{{ message.addresses }}</td>
          </ng-container>
          <ng-container matColumnDef="message">
            <th mat-header-cell *matHeaderCellDef>Üzenet</th>
            <td mat-cell *matCellDef="let message">{{ message.message }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
        </table>
      </ng-template>
      <ng-template #noMessage>
        <div class="flex-center mt-5">Nincsenek elküldött üzenetek.</div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
